import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "MedQuore - Medical Device Quality & Compliance Experts | ISO 13485, EU MDR",
  description = "Leading medical device quality and compliance company. Expert ISO 13485, EU MDR, FDA consulting. Quality assurance, audits, gap assessments for global MedTech.",
  keywords = "medical device quality, ISO 13485, EU MDR, FDA compliance, quality assurance, medical device consulting, regulatory affairs, audit support",
  canonical = "https://medquore.com/",
  ogTitle = "",
  ogDescription = "",
  ogImage = "",
  additionalMeta = []
}) => {
  // Use title as fallback for OG title if not provided
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="MedQuore" />
      <meta name="robots" content="index, follow" />
      
      {/* Canonical URL - Critical for GSC */}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="MedQuore" />
      <meta property="og:locale" content="en_US" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Additional Meta Tags */}
      {additionalMeta.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}
    </Helmet>
  );
};

export default SEOHead;